import React from "react";

/**
 * Premium CARVNY wordmark.
 * Combines a sharp custom monogram mark with a tight-kerned wordmark
 * and an editorial trademark micro-line for refinement.
 */
export default function Logo({
  size = "md",
  showTagline = true,
  invert = false,
  className = "",
  testid = "logo",
}) {
  const sizeMap = {
    sm: { mark: 24, text: "text-xl", track: "tracking-[-0.04em]" },
    md: { mark: 32, text: "text-2xl sm:text-[26px]", track: "tracking-[-0.04em]" },
    lg: { mark: 56, text: "text-5xl sm:text-6xl", track: "tracking-[-0.045em]" },
  };
  const s = sizeMap[size] || sizeMap.md;
  const ink = invert ? "text-white" : "text-carvny-ink";
  const tagline = invert ? "text-white/60" : "text-carvny-ink/55";

  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center gap-2.5 select-none ${className}`}
    >
      <Mark size={s.mark} />
      <span className={`inline-flex items-baseline gap-1.5 ${ink}`}>
        <span
          className={`font-display font-black leading-none ${s.text} ${s.track}`}
        >
          CARVNY
        </span>
        {showTagline && (
          <span
            className={`hidden sm:inline-block text-[9px] font-bold uppercase tracking-[0.24em] ${tagline} pb-[3px]`}
          >
            DXB
          </span>
        )}
      </span>
    </span>
  );
}

/**
 * Monogram mark: a hairline circle holding a sharp red "C" geometry
 * built from a partial ring + a vertical red bar — feels like a key,
 * a steering wheel, and a brand sigil all at once.
 */
function Mark({ size = 32 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      aria-hidden="true"
      className="shrink-0"
    >
      {/* Outer ring */}
      <circle cx="20" cy="20" r="18.5" stroke="#0A0A0A" strokeWidth="1.5" />
      {/* C arc — open right side */}
      <path
        d="M28.5 11.2A11.5 11.5 0 1 0 28.5 28.8"
        stroke="#CC0000"
        strokeWidth="3"
        strokeLinecap="round"
      />
      {/* Inner red bar / key notch */}
      <rect x="24" y="17.5" width="6" height="5" rx="1.2" fill="#CC0000" />
      {/* Tiny center dot */}
      <circle cx="20" cy="20" r="1.4" fill="#0A0A0A" />
    </svg>
  );
}
